import { type ComponentProps, useMemo } from "react"

import ColumnChooser from "./ColumnChooser"
import { useShownColumnIds } from "./useProductTableColumns"

type ProductTableColumnChooserProps = Omit<
  ComponentProps<typeof ColumnChooser>,
  "displayedColumnIds"
>

/**
 * The column chooser for a ProductTableV2, ticking the columns its grid shows. Reading them here
 * rather than in the table keeps a toggle from re-rendering the table.
 */
export default function ProductTableColumnChooser({
  tableId,
  columnIds,
  defaultColumnIds,
  ...props
}: ProductTableColumnChooserProps) {
  const shown = useShownColumnIds(tableId, columnIds, defaultColumnIds)
  const displayedColumnIds = useMemo(() => [...shown], [shown])
  return (
    <ColumnChooser
      columnIds={columnIds}
      displayedColumnIds={displayedColumnIds}
      defaultColumnIds={defaultColumnIds}
      tableId={tableId}
      {...props}
    />
  )
}
